module.exports = __webpack_public_path__ + "static/media/chart.4dac6616.png";